import isArray from 'lodash-es/isArray';
import isPlainObject from 'lodash-es/isPlainObject';
import transform from 'lodash-es/transform';

// leaf only
export default function traverse(obj, fn) {
  if (isArray(obj)) {
    return obj.map(val => traverse(val, fn));
  }
  if (isPlainObject(obj)) {
    return transform(obj, (res, val, key) => {
      res[key] = traverse(val, fn);
    });
  }
  return fn(obj);
}
